import { ReactElement, useState } from 'react';
import classNames from 'classnames';
import RadioSet from '../../../MDC/Radio/RadioSet/RadioSet';
import Radio from '../../../MDC/Radio/Radio';
import { LABEL_POSITIONS } from '../../../../Form/_constants';
import { CSS_CLASSES, VALUES } from './_constants';
import { propTypes as AcceptDeclinePropTypes } from './_types';
import './AcceptDecline.scss';

/**
 * Formik-compatible functional component for consuming user acceptance (OR) declination.
 *
 * @param {Object} props JSX attributes passed to component.
 * @returns {ReactElement} rendered component.
 */
const AcceptDecline = ({
	acceptLabel,
	declineLabel,
	name,
	onChange,
	...props
}) => {
	const [sIsAccepted, setIsAccepted] = useState(null);

	return (
		<RadioSet
			isVert
			labelPosition={LABEL_POSITIONS.NONE}
			name={name}
			changeHandler={e => {
				const value = e.target.value === 'true';
				setIsAccepted(value);
				if (onChange) {
					onChange(value);
				}
			}}
			{...props}
		>
			<Radio
				checked={sIsAccepted !== null && sIsAccepted}
				id={VALUES.ACCEPT}
				label={acceptLabel}
				name={name}
				wrapperClasses={classNames({
					[CSS_CLASSES.LABEL_ACCEPT]: sIsAccepted,
				})}
				value={'true'}
			/>
			<Radio
				checked={sIsAccepted !== null && !sIsAccepted}
				id={VALUES.DECLINE}
				label={declineLabel}
				name={name}
				wrapperClasses={classNames({
					[CSS_CLASSES.LABEL_DECLINE]:
						sIsAccepted !== null && !sIsAccepted,
				})}
				value={'false'}
			/>
		</RadioSet>
	);
};

AcceptDecline.propTypes = AcceptDeclinePropTypes;

export { AcceptDecline };
